import { render, staticRenderFns } from "./InviteNewMember.vue?vue&type=template&id=57ab147c&scoped=true&"
import script from "./InviteNewMember.vue?vue&type=script&lang=js&"
export * from "./InviteNewMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ab147c",
  null
  
)

export default component.exports